import { ValueOf } from "../types";
import { Base } from "./base";

export interface Document extends Base {
  name: string;
  reference: DocumentReference;
  generated: boolean;
  required?: boolean;
  fromId?: number;
  description?: string;
  status?: string;
}

export const DocumentReferenceOptions = {
  SHIPMENT: {
    BILL_OF_LADING: "shipmentbillOfLanding",
    BILL_OF_ENTRY: "shipmentBillOfEntry",
    SHIPPING_INSTRUCTIONS: "shipmentShippingInstructions",
    IMPORTER_SECURITY_FILLING: "shipmentImporterSecurityFilling",
    COMMERCIAL_INVOICE_PACKING_LIST: "shipmentCommercialInvoicePackingList",
    VERIFIED_GROSS_MASS_DECLARATION: "shipmentVerifiedGrossMassDeclaration",
    PURCHASE_ORDER: "shipmentPurchaseOrder",
    WAREHOUSE_SCAN_DATA: "shipmentWarehouseScanData",
    SSCC_CSV_UPLOADED: "SSCC CSV uploaded",
  },
};

// Add other reference objects in this type
export type DocumentReference = ValueOf<typeof DocumentReferenceOptions.SHIPMENT>;

export type DocumentReferenceShipment = ValueOf<typeof DocumentReferenceOptions.SHIPMENT>;
